import type { LocalDate } from '../../../utilities/local-date';

import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export function getDoneUpdatedText(
  doneDate: LocalDate,
  doneUpdatedAt: LocalDate,
  doneByUuid: string,
  doneUpdatedByUuid: string,
  doneByOptions: SelectDropdownOption[],
) {
  let doneUpdatedText = '';
  if (!doneDate.isSame(doneUpdatedAt)) {
    doneUpdatedText = doneUpdatedAt.toStringForDisplay();
  }
  if (doneByUuid !== doneUpdatedByUuid) {
    const doneByOption = doneByOptions.find((o) => {
      return o.value === doneUpdatedByUuid;
    });
    if (doneByOption) {
      doneUpdatedText += ' av ' + doneByOption.text;
    }
  }
  if (doneUpdatedText) {
    doneUpdatedText = ' – merket ' + doneUpdatedText + '';
  }
  return doneUpdatedText;
}
